<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <div class="headline mb-4 text-center">Reset Password</div>
        <v-card v-if="didSubmit" class="">
          <v-card-text>
            <p>We sent you an email with instructions to reset your password. Please check your inbox and make sure the email is not in the SPAM folder.</p>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-text>
            <v-card class="mb-4" v-if="error">
              <v-card-text>
                <p class="mb-0 red--text"><b>{{error.title}}:</b> {{error.message}}</p>
              </v-card-text>
            </v-card>
            <v-form id="login-form" ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
                <p>Please enter your email and we will send you instructions to set a new password.</p>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email"
                prepend-icon="email"
              ></v-text-field>
            </v-form>
            <v-btn block type="submit" :disabled="loading" :loading="loading" color="primary" form="login-form">Reset Password</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    didSubmit: false
  }),
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    onSubmit () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('resetPassword', { email: this.email }).then(() => {
          this.$refs.form.reset()
          this.didSubmit = true
        })
      }
    }
  }
}
</script>
